/*
  EBW · Contador de drop y pantalla de cierre
  Engineered by Warburton® — archivo propio, no forma parte del núcleo del tema.
*/
const pad = (n) => String(n).padStart(2, '0');

class EbwCountdown extends HTMLElement {
  connectedCallback() {
    this.cierre = Number(this.dataset.cierre) * 1000;
    this.apertura = this.dataset.apertura ? Number(this.dataset.apertura) * 1000 : 0;
    this.label = this.querySelector('.ebw-countdown__label');
    this.unidades = {};
    this.querySelectorAll('[data-unidad]').forEach((el) => {
      this.unidades[el.dataset.unidad] = el;
    });
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  tick() {
    const ahora = Date.now();
    let estado;
    let objetivo;

    if (this.apertura && ahora < this.apertura) {
      estado = 'abre';
      objetivo = this.apertura;
    } else if (ahora < this.cierre) {
      estado = 'cierra';
      objetivo = this.cierre;
    } else {
      estado = 'cerrado';
      objetivo = ahora;
    }

    if (this.dataset.estado !== estado) {
      this.dataset.estado = estado;
      if (this.label) this.label.textContent = this.label.dataset[estado] || '';
    }

    let resto = Math.max(0, Math.floor((objetivo - ahora) / 1000));
    const d = Math.floor(resto / 86400);
    resto %= 86400;
    const h = Math.floor(resto / 3600);
    resto %= 3600;
    const m = Math.floor(resto / 60);
    const s = resto % 60;

    this.pintar('d', d);
    this.pintar('h', h);
    this.pintar('m', m);
    this.pintar('s', s);
    this.toggleAttribute('data-sin-dias', d === 0);

    if (estado === 'cerrado') clearInterval(this.timer);
  }

  pintar(unidad, valor) {
    const el = this.unidades[unidad];
    if (!el) return;
    const texto = pad(valor);
    if (el.textContent !== texto) el.textContent = texto;
  }
}

class EbwDropCerrado extends HTMLElement {
  connectedCallback() {
    const enEditor = this.hasAttribute('data-design-mode');

    if (!enEditor && this.parentElement !== document.body) {
      document.body.append(this);
      return;
    }

    if (enEditor) {
      if (this.hasAttribute('data-preview')) this.abrir();
      return;
    }

    const restante = Number(this.dataset.cierre) * 1000 - Date.now();
    if (restante <= 0) {
      this.abrir();
      return;
    }
    if (restante < 2147483647) {
      this.timer = setTimeout(() => this.abrir(), restante);
    }
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
  }

  abrir() {
    this.hidden = false;
    document.documentElement.classList.add('ebw-scroll-lock');
    this.querySelector('[tabindex="-1"]')?.focus({ preventScroll: true });
  }
}

if (!customElements.get('ebw-countdown')) customElements.define('ebw-countdown', EbwCountdown);
if (!customElements.get('ebw-drop-cerrado')) customElements.define('ebw-drop-cerrado', EbwDropCerrado);
